export const BYCE_KSU_PROGRAM_IDENTITY = Object.freeze({
  slug: "ksu-building-your-clinical-ear-program",
  version: "1.0-ksu-pilot",
});

export const BYCE_LEGACY_PROGRAM_IDENTITY = Object.freeze({
  slug: "building-your-clinical-ear-g3-review-program",
  version: "0.1-september-6-review",
});

export const isAcceptedByceProgramIdentity = program => [
  BYCE_KSU_PROGRAM_IDENTITY,
  BYCE_LEGACY_PROGRAM_IDENTITY,
].some(identity => program?.slug === identity.slug && program?.version === identity.version);

export const normalizeByceProgramIdentity = program =>
  isAcceptedByceProgramIdentity(program)
    ? { ...program, ...BYCE_KSU_PROGRAM_IDENTITY }
    : program;
